(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['torso/modules/Model',
            'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // CommonJS-style exports
    var TorsoModel = require('backbone-torso/modules/Model'),
        urls = require('./../urls');
    module.exports = factory(TorsoModel, urls);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(TorsoModel, urls) {
  'use strict';

  /**
   * Model used to save payment methods to stored-payment-method datastore
   *
   * @class StoredPaymentMethodModel
   * @constructor
   */
  return TorsoModel.extend({
    urlRoot: urls.storedPaymentMethodExtService,
    idAttribute: 'vecnaId',

    /**
     * @method getExpirationYear
     * @returns {String} the year of the expiration date.
     */
    getExpirationYear: function() {
      var paymentData = this.get('paymentData');
      var expirationDate = paymentData && paymentData.card && paymentData.card.expirationDate;
      return expirationDate && expirationDate[0];
    },

    /**
     * @method getExpirationMonth
     * @returns {String} the month of the expiration date.
     */
    getExpirationMonth: function() {
      var paymentData = this.get('paymentData');
      var expirationDate = paymentData && paymentData.card && paymentData.card.expirationDate;
      return expirationDate && expirationDate[1];
    }
  });
}));
